// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {
  var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
  // var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "" : href);
    if (target.length > 0) {
      console.log(target);
      var position = target.offset().top - headerHeight;
      $("html, body").animate({ scrollTop: position }, 550, "swing");
      return false;
    }
  });
});

// ブログサムネイル 中心でトリミング // Blog thumbnail Crop at center
jQuery(function ($) {
  if ($(".obj_image").length > 0) {
    objectFitImages(".obj_image");
  }
});

// ヘッダーの固定エフェクト // Fixed header effect
jQuery(function ($) {

  var beforePos = 0;
  var $header = $('header');

  $(window).scroll(function () {

    var minFirst = 50;
    var minTop = 300;
    var scroll = $(window).scrollTop();
    //ヘッダーの出し入れをする
    if (scroll == beforePos) {
      //IE11対策で処理を入れない
    } else if (minFirst >= scroll) {
      //ヘッダーが上から出現する
      $header.removeClass('--none, --bgSet, --fixed');
    } else if (minTop >= scroll) {
      //ヘッダーが上から出現する
      $header.removeClass('--none, --bgSet');
      $header.addClass('--fixed');
    } else if (0 > scroll - beforePos) {
      //ヘッダーが上から出現する
      $header.removeClass('--none');
      $header.addClass('--fixed --bgSet');
    } else {
      //ヘッダーが上に消える
      $header.addClass('--none');
      $header.removeClass('--fixed');
    }

    beforePos = scroll;
    
  });
});

// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function ($) {
  if ($(".js-image-switch").length > 0) {
    var $elem = $(".js-image-switch");
    var sp = "_sp.";
    var pc = "_pc.";
    // 画像を切り替えるウィンドウサイズ // Window size to switch images
    var replaceWidth = 768;

    function imageSwitch() {
      var windowWidth = parseInt($(window).width());
      $elem.each(function () {
        var $this = $(this);
        if (windowWidth >= replaceWidth) {
          $this.attr("src", $this.attr("src").replace(sp, pc));
        } else {
          $this.attr("src", $this.attr("src").replace(pc, sp));
        }
      });
    }
    imageSwitch();

    var resizeTimer;
    $(window).on("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        imageSwitch();
      }, 200);
    });
  }
});

// アコーディオンの起動 // Activate the accordion
jQuery(function ($) {
  if ($("dl.accordion dt").length > 0) {
    $("dl.accordion dt").click(function () {
      $(this).next("dd").slideToggle();
      $(this).toggleClass("open");
    });
  }
});

// ドロワーメニュー // Drawer menu
jQuery(function ($) {
  if ($("#toggle").length > 0) {
    $("#toggle").click(function () {
      $(this).toggleClass("toggle_active");
      $("#drawer_layer").fadeToggle();
      $("body").toggleClass("drawer_open");

      if ($(this).hasClass("toggle_active")) {
        $("nav").addClass("is_open");
        $("nav").removeClass("is_close");
      } else {
        $("nav").removeClass("is_open");
        $("nav").addClass("is_close");
      }
    });

    $("#drawer_layer").click(function () {
      $(this).fadeOut();
      $("#toggle").removeClass("toggle_active");
      $("body").removeClass("drawer_open");
      $("nav").removeClass("is_open");
      $("nav").addClass("is_close");
    });

    // エリア内リンク用 // For links within an area
    // $("nav a").on("click", function () {
    //   // if (window.innerWidth <= 768) {
    //   if ($("#toggle:visible").length > 0) {
    //     $("#toggle").click();
    //   }
    // });
  }
});

// Navigation 
jQuery(function ($) {

  if ($(".js_nav_parent").length > 0) {
    
    $(".js_nav_parent").on('click', 'a', function() {
      var tg = $(this).next("ul");
      
      if(!$(tg).hasClass('js-active')){
        $(tg).addClass('js-active');
      } else {
        $(tg).removeClass('js-active');
        $(tg).addClass('js-nonactive');
        setTimeout(() => {
          $(tg).removeClass('js-nonactive');
        }, 2000);
      }
      if (window.matchMedia("(max-width: 1000px)").matches) {
        $(tg).slideToggle(400, 'swing');
      }
    });
  }

  function hoverEvent() {
    var tg = $(this).next("ul") ? $(this).next("ul") : $(this).children("ul");
    console.log(tg)
    switchChild(tg)
    if (window.matchMedia("(max-width: 1000px)").matches) {
      $(tg).slideToggle(400, 'swing');
    }
  };

  function switchChild(tg){
    if(!$(tg).hasClass('js-active')){
      $(tg).addClass('js-active');
    } else {
      $(tg).removeClass('js-active');
    }
  }

});

// facebookプラグインリサイズ処理 // facebook plugin resizing process
jQuery(function ($) {
  if ($("#pageplugin").length > 0) {
    var windowWidth = $(window).width();
    var htmlStr = $("#pageplugin").html();
    var timer = null;
    $(window).on("resize", function () {
      var resizedWidth = $(window).width();
      if (windowWidth != resizedWidth && resizedWidth < 500) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          $("#pageplugin").html(htmlStr);
          window.FB.XFBML.parse();
          //window.FB.XFBML.parse()で再レンダリングします。// re-render with window.FB.XFBML.parse(); window.FB.XFBML.parse()
          var windowWidth = $(window).width();
        }, 500);
      }
    });
  }
});

jQuery(function ($) {
  $(window).scroll(function () {
    $(".p-service__cont-text>div").each(function () {
      boxNum = $(this).attr("class");
      scrollTop = $(window).scrollTop();
      areaTop = $(this).offset().top;
      if (scrollTop > areaTop - 500) {
        $(".p-service__cont-image ." + boxNum).addClass("active");
      } else {
        $(".p-service__cont-image ." + boxNum).removeClass("active");
      }
    });
  });
});


jQuery(function ($) {
  if($('.js-modal-open').length > 0) {
    console.log('test')
    $('.js-modal-open').on('click', function(){
      var tgId = $(this).data('target')
      var tg = $('[data-id="'+tgId+'"');
      $(tg).toggleClass('is-opened');
      console.log('test')
    })
    $(".js-overlay,.js-modal-close").click(function () {
      var tgId = $(this).data('target')
      var tg = $('[data-id="'+tgId+'"');
      $(tg).removeClass('is-opened');
    });
  }
});
